var _circle, _path, _circle2, _circle3, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRental(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 11.5,
    r: 5.75,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.5C20 6.9087 19.3679 4.88258 18.2426 3.75736C17.1174 2.63214 15.5913 2 14 2C12.4087 2 10.8826 2.63214 9.75736 3.75736C8.63214 4.88258 8 6.4087 8 8",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 10.5,
    r: 1.75,
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 10.5,
    r: 1.75,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 17.5V28.5H6.75V17.5H5.25ZM9.75 28.5V17H8.25V28.5H9.75ZM7.5 30.75C8.74264 30.75 9.75 29.7426 9.75 28.5H8.25C8.25 28.9142 7.91421 29.25 7.5 29.25V30.75ZM5.25 28.5C5.25 29.7426 6.25736 30.75 7.5 30.75V29.25C7.08579 29.25 6.75 28.9142 6.75 28.5H5.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 25H11.5C12.3284 25 13 25.6716 13 26.5V26.5C13 27.3284 12.3284 28 11.5 28H9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.75,
    y: 6.75,
    width: 14.5,
    height: 8.5,
    rx: 1.25,
    strokeWidth: 1.5
  })));
}
export default SvgRental;